module.exports = __webpack_public_path__ + "img/medal-bg.d49b8f29.png";